import { baseGeospatial } from "../../../../api/base/baseUrl";

const BASE_URL = "/api/v1/geography-catalog/provinces";

export async function getProvinceListRequest() {
  const response = await baseGeospatial.get(`${BASE_URL}/get-all-list`);
  return response.data;
}

export async function getProvinceListByDepartmentIdRequest(departmentId) {
  const response = await baseGeospatial.get(
    `${BASE_URL}/get-by-departmentid/${departmentId}`,
  );
  return response.data;
}

export async function getProvinceByIdRequest(id) {
  const response = await baseGeospatial.get(`${BASE_URL}/get-by-id/${id}`);
  return response.data;
}

export async function createProvinceRequest(payload) {
  const response = await baseGeospatial.post(BASE_URL, payload);
  return response.data;
}

export async function updateProvinceRequest(payload) {
  const response = await baseGeospatial.put(`${BASE_URL}/update`, payload);
  return response.data;
}
